module.exports = __webpack_public_path__ + "static/media/bid-org.c8ab65c0.png";